import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'ROUND',
  category: FunctionCategory.MATH,
  description: 'Rounds each number in a column or a single number to the specified number of decimal places.',
  shortDescription: 'Rounds to number of decimal places',
  params: [
    {
      name: 'value',
      type: ArgType.number,
      description: 'Either a column or number to round to num_places number of places.',
    },
    {
      name: 'num_places',
      type: ArgType.number,
      description: 'Either a column or number, the number of places to round to.',
    },
  ],
} satisfies AnalysisFunction;
